import { DatabaseMenuItem } from "../DatabaseMenuItem";
import { MenuDataSource } from "../MenuDataSource";
import { MenuEditorTree } from "../MenuEditorTree";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";

export abstract class MenuAction {

    private _node: MenuEditorTreeNode;
    protected menuItemToSelect: DatabaseMenuItem;
    constructor(node: MenuEditorTreeNode) {
        this._node = node;
    }

    protected get menuDataSource(): MenuDataSource {
        return this.tree.menuDataSource;
    }

    get node(): MenuEditorTreeNode {
        return this._node;
    }

    get parentNode(): MenuEditorTreeNode {
        return this.node?.parent as MenuEditorTreeNode;
    }

    get tree(): MenuEditorTree {
        return this.node?.tree;
    }

    protected getNodesMatchingThisMenuItem(): MenuEditorTreeNode[] {
        return this.getAllNodesWithSameId(node => node.menuItem.itemData.get("id"));
    }

    protected getNodesMatchingThisMenuGroup(): MenuEditorTreeNode[] {
        return this.getAllNodesWithSameId(node => node.menuItem.groupData.get("id"));
    }

    private getAllNodesWithSameId(idSupplier: (node: MenuEditorTreeNode) => string): MenuEditorTreeNode[] {
        const id = idSupplier(this.node);
        const hasSameId = (node: MenuEditorTreeNode) => node !== this.node && idSupplier(node) === id;
        const otherNodes = this.node.tree.getAllNodes(hasSameId);
        return [this.node, ...otherNodes];
    }

    protected abstract internalExecute(): Promise<boolean>;

    async execute(): Promise<boolean> {
        if (!this.validate()) {
            return false;
        }

        const result = await this.internalExecute();
        if (result) {
            this.menuDataSource.notifyDataChanged();
            if (this.menuItemToSelect != null) {
                this.menuItemToSelect["__selectAfterExecute"] = true;
            }
            this.doAfterExecute();
        }
        return result;
    }

    validate(): boolean {
        return this.node != null && this.node.isMainMenuNode !== true;
    }

    protected doAfterExecute(): void {
        const nodeToSelect = this.tree.findFirstNode(node => node.menuItem["__selectAfterExecute"] === true);
        if (nodeToSelect) {
            delete nodeToSelect.menuItem["__selectAfterExecute"];
            this.tree.selectAndExpandParents(nodeToSelect);
        }
    }

    protected getActionTitle(prefix: string): string {
        return `${prefix} - ${this.node.getPathAsString() ?? this.node.text}`;
    }
}
